import React from 'react';
import { Grid, Container, TAGTypography, TAGLink, TAGButton, useMediaQuery, useTheme, Box, Rainbow } from '../../../..';

var MottoV2Footer = function MottoV2Footer(props) {
  var contentfulData = props.contentfulData;
  var data = contentfulData.footer;
  var navigationGroups = data.navigationGroups;
  var socialNetworks = data.socialNetworks;
  var exclusivelyAt = data.exclusivelyAt;
  var isLargeDevice = useMediaQuery('(min-width: 992px)');
  var theme = useTheme();
  return React.createElement("footer", {
    style: {
      position: 'relative',
      bottom: 0,
      left: 0,
      width: '100%',
      backgroundColor: theme.palette.backgrounds.darkBlue
    }
  }, React.createElement(Container, {
    maxWidth: "xl"
  }, React.createElement(Grid, {
    container: true,
    justifyContent: "space-between",
    sx: {
      padding: isLargeDevice ? '100px 0' : '30px 0'
    }
  }, React.createElement(Grid, {
    item: true,
    container: true,
    md: 6,
    justifyContent: "space-between"
  }, React.createElement(Grid, {
    item: true,
    sx: !isLargeDevice ? {
      width: '100%'
    } : {
      width: '310px'
    }
  }, React.createElement(TAGButton, {
    buttonSize: "large",
    fullWidth: true,
    buttonVariant: 'Primary Accent01',
    sx: {
      textTransform: 'none',
      width: '100%',
      background: theme.palette.secondary.dark,
      color: 'text.light',
      transition: '.3s ease',
      height: '70px',
      borderRadius: '35px',
      fontSize: '25px',
      lineHeight: '120%',
      letterSpacing: '0.01em',
      '&:hover': {
        backgroundColor: 'secondary.dark',
        color: 'text.light'
      }
    }
  }, "Book now")), isLargeDevice && React.createElement(Grid, {
    item: true,
    container: true,
    alignItems: "flex-end"
  }, React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: "text.light",
    sx: {
      marginRight: '10px',
      fontSize: '14px',
      lineHeight: '16.8px',
      letterSpacing: '10%',
      fontFamily: 'sans-serif'
    }
  }, exclusivelyAt.breadcrumbTitle || exclusivelyAt.title)), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: exclusivelyAt.path
  }, React.createElement("img", {
    src: exclusivelyAt.image.file.url,
    height: "unset",
    width: isLargeDevice ? '170px' : '125px'
  })))))), React.createElement(Grid, {
    item: true,
    container: true,
    md: 6
  }, navigationGroups.map(function (group, ind) {
    var navGroupLength = group.navigationLinksForGroup.length;
    return React.createElement(Grid, {
      md: 4,
      xs: navGroupLength > 6 ? 12 : 6,
      sx: {
        marginTop: !isLargeDevice ? '40px' : 0
      }
    }, React.createElement(Grid, {
      item: true,
      key: group.navigationGroupLink.id,
      md: 12,
      sx: {
        marginBottom: '20px'
      }
    }, React.createElement(TAGTypography, {
      variant: "h4",
      color: "secondary.main"
    }, group.navigationGroupLink.breadcrumbTitle || group.navigationGroupLink.title)), React.createElement(Grid, {
      item: true
    }, React.createElement(Box, {
      sx: !isLargeDevice && navGroupLength > 6 ? {
        columns: 2
      } : {
        columns: 1
      }
    }, group.navigationLinksForGroup.map(function (navigationItem, i) {
      return React.createElement(Box, {
        sx: {
          marginBottom: '20px'
        }
      }, React.createElement(Box, {
        sx: isLargeDevice ? {
          width: '46%'
        } : {
          width: '75%'
        }
      }, React.createElement(TAGLink, {
        key: navigationItem.id,
        href: navigationItem.path,
        color: "text.light",
        sx: {
          fontFamily: 'sans-serif',
          fontSize: '16px'
        }
      }, navigationItem.breadcrumbTitle || navigationItem.title)), i == navGroupLength - 1 && ind == navigationGroups.length - 1 && React.createElement(Grid, {
        container: true
      }, socialNetworks.map(function (socialNetwork) {
        var _socialNetwork$image, _socialNetwork$image$;

        return React.createElement(Grid, {
          item: true,
          key: socialNetwork.id,
          mt: 16,
          spacing: 2
        }, React.createElement(TAGLink, {
          href: socialNetwork.path
        }, React.createElement("img", {
          src: (_socialNetwork$image = socialNetwork.image) === null || _socialNetwork$image === void 0 ? void 0 : (_socialNetwork$image$ = _socialNetwork$image.file) === null || _socialNetwork$image$ === void 0 ? void 0 : _socialNetwork$image$.url,
          style: {
            width: '20px',
            height: '20px',
            marginRight: '8px'
          }
        })));
      })));
    }))));
  })), !isLargeDevice && React.createElement(Grid, {
    item: true,
    container: true,
    spacing: 3,
    alignItems: "center",
    marginLeft: 3
  }, React.createElement(Box, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      marginTop: '92px'
    }
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(TAGTypography, {
    color: "text.light",
    sx: {
      fontSize: '14px',
      lineHeight: '16.8px',
      letterSpacing: '10%',
      fontFamily: 'sans-serif',
      fontWeight: 'regular',
      marginRight: '10px'
    }
  }, exclusivelyAt.breadcrumbTitle || exclusivelyAt.title)), React.createElement(Grid, {
    item: true
  }, React.createElement(TAGLink, {
    href: exclusivelyAt.path
  }, React.createElement("img", {
    src: exclusivelyAt.image.file.url,
    height: "unset",
    width: "154px"
  }))))))), React.createElement(Rainbow, null));
};

export default MottoV2Footer;